import UserRepository from './user.repository'

export default UserRepository
